
import GwSection from '~/patterns/organisms/section/section.vue';
import GwAccordion from '~/patterns/atoms/accordion/accordion.vue';

export default {
    components: {
        GwSection,
        GwAccordion,
    },

    props: {
        children: {
            type: Array,
            required: true,
            default: () => { return []; }
        },
        heading: {
            type: String,
            required: false,
            default: null
        }
    }
};
